import type { MembershipJoinProps } from './membership-join.component';

/**
 * Maps HTML attribute names (kebab-case) to Component prop names (camelCase)
 */
export const MEMBERSHIP_JOIN_ATTRIBUTE_MAP: Record<string, keyof MembershipJoinProps> = {
  'tier-id': 'tierId',
  'referral-link-id': 'referralLinkId',
};

/**
 * Extracts attributes from an HTMLElement and converts them to Component props
 */
export function extractMembershipJoinAttributes(
  element: HTMLElement
): Partial<MembershipJoinProps> {
  const props: Partial<MembershipJoinProps> = {};
  for (const [attrName, propName] of Object.entries(MEMBERSHIP_JOIN_ATTRIBUTE_MAP)) {
    const value = element.getAttribute(attrName);
    if (value !== null) {
      (props as any)[propName] = value;
    }
  }
  return props;
}
